import React, { useEffect, useState } from "react";

import { useActionContext } from "./ActionContainer";
import { flattenLiquidData } from "../../../../shared/liquidUtils";

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  fontSize: 14,
  gap: 15,
};

const headerStyle = {
  borderBottom: "1px solid var(--od-c-e9eaeb, #EEEEEE)",
  color: "#33333388",
  fontSize: 10,
  paddingBottom: 5,
  width: "100%",
};

const rowStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  textWrap: "nowrap",
  width: "100%",
};

const pathStyle = {
  color: "var(--od-c-717680, #808080)",
};

const valueStyle = {
  color: "#1982C4",
};

const SampleDataContainer = () => {
  const { sampleData } = useActionContext();

  const [flattenedSampleData, setFlattenedSampleData] = useState([]);

  useEffect(() => {
    setFlattenedSampleData(flattenLiquidData(sampleData));
  }, [sampleData])

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        ATTRIBUTES
      </div>
      {flattenedSampleData.map(({ path, value }) => (
        !!value ? (
          <div key={path} style={rowStyle}>
            <div style={pathStyle}>{path}</div>
            <div style={valueStyle}>{`"${value}"`}</div>
          </div>
        ) : null
      ))}
    </div>
  );
};

export default SampleDataContainer;
